module.exports = __webpack_public_path__ + "f6dbf66528e86afbd30734d28d605777.png";


//////////////////
// WEBPACK FOOTER
// ./app/stylesheets/tablet-preview/images/status-bar.png
// module id = 1105
// module chunks = 4